export default "__VITE_ASSET__ChjL$CiY__"